import { lazy } from "react";

export { SYSTEM_CHECK_PATH } from "./path";
export const SystemCheckPage = lazy(() => import("./page"));
